var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ProcessActionService = /** @class */ (function (_super) {
            __extends(ProcessActionService, _super);
            function ProcessActionService(injectedBreeze, $q, $http, worflowService) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                _this.worflowService = worflowService;
                return _this;
            }
            ProcessActionService.prototype.getAllProcessActions = function (processConfigId) {
                var query = this.breezeModule.EntityQuery
                    .from("ProcessActions")
                    .where("processConfiguration_id", "==", processConfigId)
                    .orderBy("name");
                return this.executeQuery(query);
            };
            ProcessActionService.prototype.createNewProcessAction = function (processConfigId) {
                var newProcessAction = this.createNewEntity("ProcessAction");
                newProcessAction.name = "New Process Action";
                newProcessAction.processConfiguration_id = processConfigId;
                var newStartProcessActionWorkflowBlock = this.createNewEntity("StartProcessActionWorkflowBlock");
                newStartProcessActionWorkflowBlock.blockType = 15 /* StartProcessAction */;
                newStartProcessActionWorkflowBlock.uniqueIdentifier = services.UtilityService.generateGuidComb();
                newStartProcessActionWorkflowBlock.myProcessAction = newProcessAction;
                newStartProcessActionWorkflowBlock.isInitialWorkflowBlock = true;
                newStartProcessActionWorkflowBlock.name = "Start";
                newStartProcessActionWorkflowBlock.description = "Entry point to the Process Action";
                newProcessAction.myWorkflowBlocks.push(newStartProcessActionWorkflowBlock);
                return newProcessAction;
            };
            ProcessActionService.prototype.getProcessActionGroup = function (processActionId) {
                var _this = this;
                var d = this.$q.defer();
                this.$http.get('./api/ProcessAction/' + processActionId).then(function (result) {
                    var processActionGroupDto = result.data;
                    var processActionGroup = new warsApp.models.ProcessActionGroup();
                    var blocks = _this.worflowService.bindBlockList(processActionGroupDto.workflowBlocks);
                    processActionGroup.intitialize(processActionGroupDto, blocks);
                    d.resolve(processActionGroup);
                });
                return d.promise;
            };
            return ProcessActionService;
        }(services.DataService));
        services.ProcessActionService = ProcessActionService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('ProcessActionService', ['breeze', '$q', '$http', 'workflowService']);
